import { PublicLayout } from "@/components/PublicLayout";
import { SectionHeading } from "@/components/shared";
import { Target, Eye, ShieldCheck, Users } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1569660424259-87e64a80f6fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  const vals = [
    { icon: Target, t: "Our Mission", d: "To provide a transparent, secure and modern platform for managing digital asset activity with institutional-grade controls." },
    { icon: Eye, t: "Our Vision", d: "To make sophisticated digital asset technology approachable, clear and accessible to users worldwide." },
    { icon: ShieldCheck, t: "Security", d: "Server-side balance management, audit logging and encrypted document handling underpin everything we build." },
    { icon: Users, t: "Community", d: "A one-level direct referral program that rewards users for growing the AI TECHNOLOGY community." },
  ];
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-8">
        <SectionHeading eyebrow="About Us" title="Building trusted digital asset technology"
          subtitle="AI TECHNOLOGY is a digital asset technology platform focused on transparency, security and a premium user experience. We do not promise guaranteed profit — participation in digital assets carries significant risk." />
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="space-y-5 text-slate-400 leading-relaxed">
            <p>AI TECHNOLOGY provides the infrastructure to deposit, manage and withdraw digital assets through a clean, responsive interface. All financial state changes are validated server-side and recorded transparently.</p>
            <p>Our platform includes a structured deposit review workflow, withdrawal request management, a direct referral program and optional identity verification — all managed through a powerful administrative console.</p>
            <p>We are a technology company. We do not fabricate statistics, testimonials or regulatory claims. Any earnings percentages shown are variable, non-guaranteed and subject to the applicable terms and risk disclosure.</p>
          </div>
          <div className="rounded-2xl overflow-hidden glass">
            <img src={IMG} alt="Infrastructure" className="w-full h-80 object-cover" />
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid sm:grid-cols-2 gap-6">
          {vals.map((v) => (
            <div key={v.t} className="glass glass-hover rounded-2xl p-7">
              <div className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center mb-4">
                <v.icon className="w-6 h-6 text-cyan-300" />
              </div>
              <h3 className="font-heading text-lg text-white mb-2">{v.t}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
